import { RegisterModule } from '@/typings/common'
import {
  LkRegMehState,
  LkRegMehGetters,
  LkRegMehMutations,
  LkRegMehActions,
} from './store'
import { createMapper, registerModule as vuexRegisterModule, Module } from 'vuex-smart-module'
import { MODULE_NAME } from '../utils'


const storeModule = (
  new Module({
    namespaced: true,
    state: LkRegMehState,
    getters: LkRegMehGetters,
    mutations: LkRegMehMutations,
    actions: LkRegMehActions,
  })
)

const mapper = createMapper(storeModule)

export {
  storeModule as lkRegMehStoreModule,
  mapper as lkRegMehMapper,
}

export const registerModule: RegisterModule = ({ store }): void => {
  if (registerModule.installed) return

  vuexRegisterModule(
    store,
    MODULE_NAME,
    MODULE_NAME,
    storeModule,
  )

  registerModule.installed = true
}
